/* START_MODULE_CONTRACT
 * PURPOSE: Модель фактических часов работы над задачей (UC-016).
 * SCOPE: fromResponse mapping.
 * DEPENDS: нет
 * LINKS: M-TASK-ACTUAL-HOURS
 * END_MODULE_CONTRACT
 */

export default class TaskActualHours {
  constructor({
    id,
    featureId,
    projectRoleId,
    workDate,
    actualHours,
  }) {
    this.id = id;
    this.featureId = featureId;
    this.projectRoleId = projectRoleId;
    this.workDate = workDate;
    this.actualHours = actualHours;
  }

  static fromResponse(data) {
    return new TaskActualHours({
      id: data.id,
      featureId: data.featureId,
      projectRoleId: data.projectRoleId,
      workDate: data.workDate,
      actualHours: data.actualHours,
    });
  }
}
